import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ChartPie } from 'common/charts';
import { fetchContactsReports } from 'actions/Report/Contact';
import _ from 'lodash';
import { genderColors } from '../../utils/colors';

export default class ContactsByGender extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.state = {
      contactsByGender: [],
      title: '',
    };
  }

  componentDidMount() {
    this.fetchData(this.props.filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const filtersChanged = !_.isEqual(this.props.filters, nextProps.filters);
    const networkChanged = !_.isEqual(this.props.id, nextProps.id);

    if (filtersChanged || networkChanged) {
      this.fetchData(nextProps.filters, nextProps.id);
    }
  }

  fetchData(filters, id = this.props.id) {
    const { scope } = this.props;
    fetchContactsReports(scope, id, 'by-gender', filters)
      .then((response) => {
        this.setState({
          contactsByGender: _.orderBy(_.get(response, 'data.values', []), 'title', 'asc'),
          title: _.get(response, 'data.title', ''),
        });
        this.props.loaded('contactsByGender');
      });
  }

  render() {
    if (_.isEmpty(this.state.contactsByGender)) {
      return null;
    }
    return (
      <ChartPie
        data={this.state.contactsByGender}
        title={this.state.title}
        x={(d) => d.title}
        y={(d) => d.total}
        style={{ height: '350px' }}
        valueFormat="d"
        twoColsLegend={false}
        colors={genderColors}
      />
    );
  }
}

ContactsByGender.propTypes = {
  filters: PropTypes.shape({
    end_date: PropTypes.string,
    network_ids: PropTypes.array,
    start_date: PropTypes.string,
  }),
  loaded: PropTypes.func.isRequired,
  scope: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};
